var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          class: _vm.customClasses,
          attrs: {
            title: _vm.title,
            backdrop: _vm.allowModalToBeClosed,
            "append-to-body": true
          },
          on: { hide: _vm.close },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _vm._t("default", function() {
            return [
              _c("p", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CONFIRM_MESSAGE",
                    expression: "'CONFIRM_MESSAGE'"
                  }
                ]
              })
            ]
          }),
          _vm._v(" "),
          !_vm.showHeaderCloseButton
            ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: _vm.title,
                      expression: "title"
                    }
                  ],
                  staticClass: "modal-title"
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.showCustomButton
                ? _c(
                    "btn",
                    {
                      attrs: {
                        type: "primary",
                        disabled:
                          _vm.confirmButtonDisabled ||
                          _vm.showConfirmButtonLoading
                      },
                      on: { click: _vm.customAction }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.confirmCustomActionText) +
                          "\n        "
                      ),
                      _vm.showConfirmButtonLoading
                        ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showConfirmButton
                ? _c(
                    "btn",
                    {
                      attrs: {
                        type: "primary",
                        disabled:
                          _vm.confirmButtonDisabled ||
                          _vm.showConfirmButtonLoading
                      },
                      on: { click: _vm.confirm }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.confirmActionText) +
                          "\n        "
                      ),
                      _vm.showConfirmButtonLoading
                        ? _c("Loader", { attrs: { "custom-class": "size-sm" } })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCancelButton
                ? _c("btn", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "CANCEL",
                        expression: "'CANCEL'"
                      }
                    ],
                    attrs: {
                      disabled:
                        _vm.cancelButtonDisabled || _vm.isConfirmLoading,
                      type: "danger"
                    },
                    on: { click: _vm.close }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }